import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { normalizeBaseUrl } from './normalize-base-url.util';
import { STAFF_HTTP_API_BASE_URL } from './staff-http.config';

/**
 * orval 생성 클라이언트는 base URL 없이 상대 경로(`/staff/...`)로 요청을 만든다 — 이 인터셉터가
 * `STAFF_HTTP_API_BASE_URL` 을 접두어로 붙인다.
 *
 * 등록 순서 규약: `staffApiBaseUrlInterceptor` → `staffCredentialsInterceptor` → 401 처리
 * 인터셉터. 401 처리 인터셉터가 절대 URL 기준으로 auth 라우트를 판별하므로 base URL 인터셉터가
 * 반드시 먼저 실행돼야 한다.
 */
export const staffApiBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const baseUrl = inject(STAFF_HTTP_API_BASE_URL);
  if (!baseUrl || !req.url.startsWith('/')) return next(req);
  return next(req.clone({ url: `${normalizeBaseUrl(baseUrl)}${req.url}` }));
};
